import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { groupVariantPatches } from "functions/tlf/groupVariantPatches";
import { applySelection } from "./applySelection";
import { commitActivePatch } from "./commitActivePatch";
import {
  ITlfActionToggleVariantPatch,
  SET_VARIANT_CREATION_VIEW,
  TlfContextProps,
} from "./interface";
import { tlf_setVariantCreationMode } from "./tlf_setVariantCreationMode";
import { toArsTlfSnapshot } from "./toArsTlfSnapshot";
import { updateActivePatchErrors } from "./updateActivePatchErrors";

/**
 * Commits the active patch, composes the requested patch set, and activates applied patches.
 *
 * @param state - Current TLF context state
 * @param action - Patch to apply or remove
 * @returns State containing the updated patch composition
 */
export const tlf_toggleVariantPatch = (
  state: TlfContextProps,
  action: ITlfActionToggleVariantPatch,
): TlfContextProps => {
  const { state: committedState, catalog } = commitActivePatch(state, action.calledFrom);
  if (catalog === null) return committedState;
  const selectedGroup = groupVariantPatches({ allVariantPatches: catalog, variantTemplates: [] })
    .filter((group) => group.includes(action.patchName))
    .flat();
  const appliedPatchNames = action.applied
    ? [
        ...state.appliedVariantPatches.filter((name) => !selectedGroup.includes(name)),
        action.patchName,
      ]
    : state.appliedVariantPatches.filter((name) => name !== action.patchName);
  const firstPatchApplied = action.applied && state.appliedVariantPatches.length === 0;
  const currentItem = isArsMasterReadDto(committedState.tlfData) ? committedState.tlfData : null;
  const patchState =
    firstPatchApplied && currentItem !== null
      ? { ...state, masterTlfData: toArsTlfSnapshot(currentItem) }
      : state;
  const activePatchName = action.applied
    ? action.patchName
    : (state.activeVariantPatchName ?? action.patchName);
  let newState = applySelection(
    patchState,
    appliedPatchNames,
    catalog,
    activePatchName,
    action.calledFrom,
  );
  if (
    newState !== patchState &&
    (action.applied || (appliedPatchNames.length === 0 && state.variantCreationView))
  ) {
    newState = tlf_setVariantCreationMode(newState, {
      operation: SET_VARIANT_CREATION_VIEW,
      variantCreationView: action.applied,
      calledFrom: action.calledFrom,
    });
  }
  return updateActivePatchErrors(newState);
};
